import styled from 'styled-components';
import { asRem } from 'utils';
import { Link } from 'react-router-dom';
import { breakpoints } from 'components/Theme';

export default styled(Link)`
  &.library-list-item--zpp-course {
    .library-list-item__content {
      padding-top: ${asRem(12)};

      @media (min-width: ${breakpoints.md}) {
        padding-top: ${asRem(12)};
      }

      @media (min-width: ${breakpoints.lg}) {
        padding-top: ${asRem(16)};
      }
    }
  }
`;
